import { Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '_metronic/layout/core'
import { ExamesListWrapper } from './exames-list/ExamesList'
import { useT } from '_metronic/i18n/Metronici18n'

const ExamesPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.exames.descricao')}>{t('menu.exames')}</PageTitle>
              <ExamesListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default ExamesPage
